import { useContext } from 'react';
import { GameDayContext, type GameDayContextValue } from '@/app/providers/GameDayProvider';

export function useGameDayStatus(): GameDayContextValue {
  const context = useContext(GameDayContext);
  if (!context) {
    throw new Error('useGameDayStatus must be used within a GameDayProvider');
  }
  return context;
}
